import classNames from 'classnames';
import React from 'react';

interface PageHeaderProps {
  children: any;
  mobileColumn?: boolean;
  multipleRows?: boolean;
}

const PageHeader = ({ children, mobileColumn, multipleRows }: PageHeaderProps) => {
  return (
    <header
      className={classNames('page-header', {
        'page-header--mobile-column': mobileColumn,
        'page-header--multiple-rows': multipleRows,
      })}
    >
      {children}
    </header>
  );
};

export default PageHeader;
